import { useState } from 'react';
import { useReducedMotion } from '../../lib/motion';

function Star() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <path d="M12 1l2.6 8.4L23 12l-8.4 2.6L12 23l-2.6-8.4L1 12l8.4-2.6z" fill="currentColor" />
    </svg>
  );
}

/**
 * #4 Franja de marca en loop. Se pausa con hover/focus, con el botón de pausa y con reduced-motion.
 * El contenido duplicado va con aria-hidden; los lectores leen una sola vez.
 */
export default function Marquee({ items = [], speed = 28, className = '' }) {
  const reduced = useReducedMotion();
  const [paused, setPaused] = useState(false);
  if (!items.length) return null;
  const group = (hidden) => (
    <div className="t-marquee__group" aria-hidden={hidden || undefined}>
      {[...items, ...items].map((t, i) => (
        <span key={`${hidden ? 'b' : 'a'}-${i}`} className="t-marquee__item">
          {t}
          <Star />
        </span>
      ))}
    </div>
  );
  return (
    <div
      className={`t-marquee relative py-3 ${paused || reduced ? 'is-paused' : ''} ${className}`}
      style={{ '--speed': `${speed}s` }}
    >
      <p className="sr-only">{items.join(' · ')}</p>
      <div className="t-marquee__track" aria-hidden="true">
        {group(false)}
        {group(true)}
      </div>
      <button
        type="button"
        onClick={() => setPaused((p) => !p)}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-black/25 text-white text-xs font-semibold px-2.5 py-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"
        aria-label={paused ? 'Reanudar animación de la franja' : 'Pausar animación de la franja'}
      >
        {paused ? '▶' : '❚❚'}
      </button>
    </div>
  );
}
